<template>
    <div id="emPowerAsPro">
        <div class="mybreadcrumb">
            <i class="iconfont icon-shouquan-tianchong" style="margin-right:10px;color:#999"></i>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>授权管理</el-breadcrumb-item>
                <el-breadcrumb-item>按产品</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <p class="asmember-tittle">所有产品({{total}})</p>
        <div style="padding:0 30px 30px 30px">
            <el-table
            :data="tableData"
            border
            :header-cell-style="{color:'#333333',fontFamily:'MicrosoftYaHei',fontSize:'12px',fontWeight:400,padding:'9px 0',background:'#F5f5f5'}"
            style="width: 100%"
            :cell-class-name="tabCellClassName">
            <el-table-column
                    label="序号"
                    type="index"
                    width="60"
                    align="center"
                    >
                <template slot-scope="scope">
                    <span>{{(pageIndex-1) * pageSize + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column
            prop="productName"
            label="名称"
            align="center"
            show-overflow-tooltip>
            </el-table-column>
            <el-table-column
            prop="expirydate"
            label="有效期"
            width="185"
            align="center">
            </el-table-column>
            <el-table-column
            label="可用授权"
            width="120"
            align="center">
                <template slot-scope="scope">
                    <span style="color:#0069e0">{{scope.row.unUsedCount}}</span>
                    <span>({{scope.row.totalCount}})</span>
                </template>
            </el-table-column>
            <el-table-column
            prop="isActive"
            label="授权状态"
            width="105"
            align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.snStatus==='正常'" class="table-status bgcgreen">
                            <span>{{scope.row.snStatus}}</span>
                        </div>
                        <div v-else-if="scope.row.snStatus==='禁用'||scope.row.snStatus==='已禁用'" class="table-status bgcred">
                            <span>{{scope.row.snStatus}}</span>
                        </div>
                        <div v-else-if="scope.row.snStatus==='过期'||scope.row.snStatus==='已过期'" class="table-status bgcorange">
                            <span>{{scope.row.snStatus}}</span>
                        </div>
                        <div v-else>
                            <span>{{scope.row.snStatus}}</span>
                        </div>
                </template>
            </el-table-column>
            <el-table-column
            align="center"
            label="操作"
            width="140">
            <template slot-scope="scope">

                <div @click="managepower(scope.row)" :class="scope.row.snStatus==='正常'?'manage-button':'dismanage-button'">管理授权</div>
            </template>
            </el-table-column>
            <el-table-column
                    prop="remarks"
                    label="备注"
                    show-overflow-tooltip
                    align="center">
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,30,50,100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-size="pageSize"
                :current-page="pageIndex"
                style="margin-top:30px">
        </el-pagination>
        </div>
        

        
    </div>
</template>

<script>
import {GrantSNByProduct} from '@/js/enterPriseApi'
import {MyZhugeTrackClickManPower} from '@/js/zhugemaidian.js'
import Moment from 'moment'
export default {
    name:"allProAndSer",
    data(){
        return {
            pageSize:10,
            pageIndex:1,
            total:0,
            hasPreviousPage:false,
            status:"1",
            tableData: []
            }
    },
    created(){
        if(this.$route.query.pageIndex){
            this.pageIndex=Number(this.$route.query.pageIndex)
            this.pageSize=Number(this.$route.query.pageSize)
        }
        this.getGrantSNByProduct(this.pageIndex,this.pageSize);
    },
    methods:{
        tabCellClassName({row, column, rowIndex, columnIndex}){
            return 'cellstyle'
        },
        getGrantSNByProduct(pageindex,pagesize){
            let that=this;
            let params={
                enterPriseId:window.localStorage.getItem('enterPriseId'),
                pageIndex:pageindex,
                pageSize:pagesize,
                
            }
            GrantSNByProduct(params)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    that.tableData=[];
                    that.total=0;
                    that.total=data.totalItems;
                    that.hasPreviousPage=data.hasPreviousPage;
                    if(data.hasOwnProperty('list')&&data.list.length>0){
                        data.list.forEach(item=>{
                            let obj={
                                mainId:item.mainId,
                                productName:item.productName,
                                expirydate:Moment(item.startTime).format('YYYY.MM.DD')+'-'+ Moment(item.endTime).format('YYYY.MM.DD'),
                                unUsedCount:item.unUsedCount,
                                totalCount:item.totalCount,
                                isActive:item.isActive,
                                snStatus:item.snStatus,
                                productType:item.productType,
                                licensingType:item.licensingType,
                                remarks:item.remarks
                            }
                            if(obj.licensingType=='永久版'){
                                obj.expirydate='永久'
                            }
                            that.tableData.push(obj)
                        })
                    }else{
                        console.log('无授权产品')
                    }
                }else{
                    that.$message.error(res.data.error_msg)
                }    
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data)
                }
            })
        },
        handleSizeChange(val){//每页多少改变触发
            let that=this;
            this.pageSize=val;
            this.getGrantSNByProduct(that.pageIndex,val)
        },
        handleCurrentChange(currentpage){//当前页数切换
            let that=this;
            this.pageIndex=currentpage
            that.getGrantSNByProduct(currentpage,that.pageSize)
        },
        managepower(row){
            console.log(row)
            //if(!row.isActive)
            if(row.snStatus!="正常")
            return

            let queryinfo={
                productName:row.productName,
                mainId:row.mainId,
                productType:row.productType,
                pageSize:this.pageSize,
                pageIndex:this.pageIndex
            }
            MyZhugeTrackClickManPower({
                "管理方式":'按产品'
            })
            this.$router.push({
                path:'/manageAsPro',
                query:queryinfo
            })
        }
    }
     
}
</script>

<style lang="scss" scoped>
    #emPowerAsPro{
        background: #fff;
        /deep/ .el-breadcrumb{
            .el-breadcrumb__inner{
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                font-weight: 400;
            }
            .el-breadcrumb__separator{
                font-size: 12px !important;
                color: #666666;
            }
        }
        .mybreadcrumb{
            display: flex;
            align-items: center;
            padding: 13px 0 13px 20px;
            border-bottom: 1px solid #EAEAEA;
        }
        .asmember-tittle{
            text-align: left;
            padding: 20px 0 15px 30px;
            font-family: FZLTZHK--GBK1-0;
            font-size: 14px;
            color: #333333;
            font-weight:600
        }
        .table-status{
            span{
                margin-left: 8px;
            }
        }
        .bgcorange::before{
                content:'';
                width: 10px;
                height: 10px;
                border-radius: 50%;
                display: inline-block;
                background: #FE833D;
            }
        .bgcred::before{
                content:'';
                width: 10px;
                height: 10px;
                border-radius: 50%;
                display: inline-block;
                background: #fe3d3d;
            }
        .bgcgreen::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #1DCB96;
        }
        .manage-button{
            width: 70px;
            height: 26px;
            line-height: 25px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #0069E0;
            font-weight: 400;
            background: #F0F6FD;
            border: 1px solid rgba(0,105,224,0.45);
            border-radius: 2px;
            margin: 0 auto;
            cursor: pointer;
        }
        .dismanage-button{
            width: 70px;
            height: 26px;
            line-height: 25px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #c0c4cc;
            font-weight: 400;
            background: #fff;
            border: 1px solid #ebeef5;
            border-radius: 2px;
            margin: 0 auto;
            cursor: pointer;
        }
        /deep/ .el-table .cellstyle{
            padding: 0px;
            height: 40px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #181818;
            font-weight: 400;
        }
    }
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/EmPowerManage/EmPowerAsPro.vue